import { Crown, Mail, Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const XIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Footer = ({ onUpgradeClick }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1a1a] text-white mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-10 mb-8 sm:mb-12">
          {/* About */}
          <div>
            <h4 className="text-sm font-semibold text-[#00bf63] uppercase tracking-wider mb-4">About</h4>
            <p className="text-sm text-gray-400 leading-relaxed">
              ScoreXprt delivers real-time Indian sports scores — Cricket, Football, Hockey, Badminton & more. Stay connected to the games you love.
            </p>
          </div>

          {/* Coverage */}
          <div>
            <h4 className="text-sm font-semibold text-[#00bf63] uppercase tracking-wider mb-4">Coverage</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Indian Premier League</li>
              <li>Indian Super League</li>
              <li>Indian Cricket</li>
              <li>BWF Badminton</li>
              <li>Hockey & more</li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-semibold text-[#00bf63] uppercase tracking-wider mb-4">Connect</h4>
            <div className="flex items-center gap-3 mb-4">
              <a 
                href="https://www.facebook.com/scorexprt" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#00bf63] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://x.com/ScoreXprt" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#00bf63] transition-colors"
                data-testid="social-twitter"
              >
                <XIcon className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/scorexprt/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#00bf63] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.youtube.com/@ScoreXprt" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#00bf63] transition-colors"
                data-testid="social-youtube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Mail className="w-4 h-4" />
              <a href="mailto:info@scorexprt.com" className="hover:text-[#00bf63] transition-colors">
                info@scorexprt.com
              </a>
            </div>
          </div>

          {/* Premium */}
          <div>
            <h4 className="text-sm font-semibold text-[#00bf63] uppercase tracking-wider mb-4">Go Premium</h4>
            <p className="text-sm text-gray-400 mb-4">
              Remove ads and enjoy uninterrupted sports scores.
            </p>
            <button
              onClick={onUpgradeClick}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#00bf63] text-white text-sm font-medium rounded-full hover:bg-[#00a854] transition-colors shadow-md"
              data-testid="footer-upgrade-btn"
            >
              <Crown className="w-4 h-4" />
              Upgrade Now
            </button>
          </div>
        </div>

        {/* Bottom Links */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-500">
            © {currentYear} ScoreXprt. All rights reserved.
          </div>
          
          <div className="flex items-center gap-6 text-sm text-gray-400">
            <Link to="/Privacypolicy" className="hover:text-[#00bf63] transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/TermsofService" className="hover:text-[#00bf63] transition-colors" data-testid="footer-tos-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
